const state = {
  sort: 'transaction',
  date: '',
  search: '',
  logs: [],
  logsLoading: false,
  logsError: false,
  selectedLogs: [],
  currentTab: 'sticker',
  stickerTransactions: [],
  stripeTransactions: [],
  benevityTransactions: [],
  benevityW2WCreditTransactions: [],
  stickerLoading: false,
  stripeLoading: false,
  benevityLoading: false,
  benevityW2WLoading: false,
  stickerError: false,
  stripeError: false,
  benevityError: false,
  benevityW2WError: false,
};

export default state;
